import { ColumnsType } from 'antd/es/table';
import React, { useLayoutEffect } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Button, PaginationProps, Popconfirm, Table } from 'antd';
import { DeleteOutlined, LockOutlined } from '@ant-design/icons';
import { tenantApi } from '../../api/tenant.api';
import EditTenantModal from './EditTenantModal';
import { ADAPTIVE_TABLE_CONTAINER_CLASS, useAdaptivePageSize } from '../../hooks/useAdaptivePageSize';

export interface TenantRow {
  uuid: string;
  name: string;
  adminNames?: string;
}

interface TenantsTableProps {
  tenants: TenantRow[];
  onSuccess?: () => void;
  loading?: boolean;
  pagination: PaginationProps;
  onChange: (pagination: PaginationProps) => void;
}

const TenantsTable = ({ tenants, onSuccess, loading, pagination, onChange }: TenantsTableProps) => {
  const { t } = useTranslation('tenants', { keyPrefix: 'table' });
  const { containerRef, containerHeight, recalculate } = useAdaptivePageSize();

  useLayoutEffect(() => {
    recalculate();
  }, [tenants, recalculate]);

  const handleDeleteTenant = async (tenantId: string) => {
    try {
      await tenantApi.deleteTenant(tenantId);
      onSuccess?.();
    } catch (e) {
      throw e;
    }
  };

  const columns: ColumnsType<TenantRow> = [
    {
      title: t('name'),
      dataIndex: 'name',
      key: 'name',
      width: '25%',
    },
    {
      title: t('admin'),
      dataIndex: 'adminNames',
      key: 'adminNames',
      width: '25%',
    },
    {
      title: t('actions'),
      width: '15%',
      render: (record) => (
        <div>
          <EditTenantModal uuid={record.uuid} name={record.name} onSuccess={onSuccess} />
          <Popconfirm
            title={t('confirmation')}
            okText={t('yes')}
            placement={'left'}
            onConfirm={() => handleDeleteTenant(record.uuid)}
          >
            <Button type={'text'}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
          <Popconfirm title={t('block')} okText={t('yes')}>
            <Button type={'text'} style={{ display: 'none' }}>
              <LockOutlined style={{ color: 'red' }} />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];
  return (
    <div
      className={`TenantsTable__container ${ADAPTIVE_TABLE_CONTAINER_CLASS}`}
      style={{ height: containerHeight }}
      ref={containerRef}
    >
      <Table
        size={'large'}
        columns={columns}
        dataSource={tenants}
        rowKey="uuid"
        loading={loading}
        pagination={{ ...pagination }}
        onChange={onChange}
      />
    </div>
  );
};

export default TenantsTable;
